<template>
  <section>
    <el-row style="margin-top: 10px">
      <el-col>
        <el-card>
          <div slot="header">
            RS 订阅结果解析
          </div>
          <el-row>
            <el-col :span="24">
              <el-form :model="form" label-width="100px" label-position="right" style="width: 100%" v-loading="loading">
                <el-form-item label="代理模式:">
                  <el-radio-group v-model="form.proxyMode">
                    <el-radio :label="item.value" :key="item.value" v-for="item in proxyOptions" border
                              style="margin-bottom: 10px;">{{ item.label }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="UserAgent:">
                  <el-radio-group v-model="form.userAgent">
                    <el-radio :label="item.value" :key="item.value" v-for="item in userAgentOptions" border
                              style="margin-bottom: 10px;">{{ item.label }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>

                <el-form-item label="订阅链接:">
                  <el-input v-model="form.sourceSubUrl"
                            class="sub-input"
                            type="textarea"
                            rows="6"
                            clearable
                            placeholder="支持Https订阅链接" @blur="saveSubUrl"/>
                </el-form-item>

                <el-form-item>
                  <div style="display: flex; justify-content: center;">
                    <el-button style="width: 180px" type="danger" @click="parserSubUrl"
                               :disabled="form.sourceSubUrl.length === 0">AJAX解析订阅链接
                    </el-button>
                    <!--                    <el-button style="width: 180px" type="warning" @click="parserSubUrl" :loading="loading"-->
                    <!--                    >【suo.yt】生成短链接-->
                    <!--                    </el-button>-->
                  </div>
                </el-form-item>

                <el-form-item label="" v-if="form.parserContent" style="margin-top: 35px;">
                  <div style="display:  flex;justify-content: end;">
                    <span style="font-size: 16px;">解析节点数量: <span
                        style="font-size: 20px;font-weight: bold;">{{ form.nodesCount }}</span> 条</span>
                  </div>
                </el-form-item>

                <el-form-item label="解析结果:" v-if="form.parserContent">
                  <el-input v-model="form.parserContent"
                            type="textarea"
                            clearable
                            autosize
                            placeholder="显示解析后的结果"/>
                </el-form-item>

              </el-form>
            </el-col>
          </el-row>

        </el-card>
      </el-col>
    </el-row>
  </section>
</template>

<script>
const subConfigApi = process.env.VUE_APP_MYURLS_CUSTOM_API.slice(0, process.env.VUE_APP_MYURLS_CUSTOM_API.indexOf("/short"))

const yaml = require('js-yaml');

export default {
  components: {},
  data() {
    return {
      // 是否为 PC 端
      isPC: true,

      proxyUrl: 'https://proxy.sauth.cn/',

      form: {
        proxyMode: '1',
        userAgent: undefined,
        sourceSubUrl: "",
        parserContent: "",
        nodesCount: 0,
      },

      userAgentOptions: [],

      proxyOptions: [
        {label: '1.不代理', value: '1'},
        {label: '2.使用代理', value: '2'}
      ],

      loading: false,
    };
  },

  watch: {
    'form.proxyMode': {
      handler(newValue, oldValue) {
        if(newValue){
          this.replaceProxyUrl(newValue)
        }
      },
      //true表示会立即执行
      immediate: true,
      deep: true
    },
    'form.sourceSubUrl': {
      handler(newValue, oldValue) {
        if(newValue){
          this.replaceProxyUrl(newValue)
        }
      },
      //true表示会立即执行
      immediate: true,
      deep: true
    }
  },
  created() {
    document.title = "RS订阅解析服务";
    this.isPC = this.$getOS().isPc;

    // 获取 url cache
    if (process.env.VUE_APP_USE_STORAGE === 'true') {
      this.form.sourceSubUrl = this.getLocalStorageItem('sub_parser_source_sub_url')
    }

  },
  mounted() {
    this.fetchSubRemoteConfig()
  },
  methods: {

    // 在新页面打开链接
    openNewPage(url) {
      window.open(url, '_blank');
    },


    /**
     * 动态替换代理地址
     * @param proxyMode
     */
    replaceProxyUrl(proxyMode){
      if(proxyMode === '1'){
      }else if(proxyMode === '2'){
      }
    },

    /**
     * 获取远程配置
     */
    fetchSubRemoteConfig() {
      let _this = this

      let remoteApiOptionsUrl = `${subConfigApi}/subConfig/userAgentOptions`
      _this.$axios.get(remoteApiOptionsUrl).then(res => {
        let response = res.data
        if (response.code === 200) {
          _this.userAgentOptions = response.data

          if (_this.userAgentOptions && _this.userAgentOptions.length > 0) {
            _this.form.userAgent = _this.userAgentOptions[0].value
          }
        }
      }).catch(err => {
        console.error(err)
      });

    },

    onCopy() {
      this.$message.success("复制成功!");
    },


    countLines(str) {
      // 使用换行符对字符串进行分割，然后返回分割后数组的长度
      return str.split('\n').length;
    },

    isBase64(str) {
      // 使用正则表达式检查字符串是否符合Base64格式
      return /^[A-Za-z0-9+/=]*$/.test(str);
    },

    isYaml(str) {
      try {
        let yamlObj = yaml.load(str);
        console.log('解析成功')
        return true; // 解析成功，说明是YAML格式
      } catch (e) {
        console.warn(e)
        return false; // 解析失败，说明不是YAML格式
      }
    },


    parserSubUrl() {
      if (this.form.sourceSubUrl && this.form.sourceSubUrl.length === 0) {
        this.$message.warning("请先填写订阅链接");
        return false;
      }

      this.form.parserContent = "";
      this.form.isYamlType = false;
      this.loading = true;
      this.$axios.post(this.form.sourceSubUrl, {
        timeout: 1000 * 60 * 2 // 设置超时时间为2分钟
      }).then(res => {

        let parserContent = res.data

        if (this.isBase64(parserContent)) {
          parserContent = atob(parserContent)
        }

        this.form.nodesCount = this.countLines(parserContent)
        this.form.parserContent = parserContent

        this.loading = false;

      }).catch((err) => {
        this.loading = true;
        this.parserProxySubUrl();
      }).finally(() => {
        //this.loading = false;
      });
    },

    parserProxySubUrl() {
      if (this.form.sourceSubUrl && this.form.sourceSubUrl.length === 0) {
        this.$message.warning("请先填写订阅链接");
        return false;
      }

      let remoteApiProxyUrl = `${subConfigApi}/apiProxy/proxyRequest`
      let params = {
        requestUrl: this.form.sourceSubUrl,
        userAgent: this.form.userAgent,
        proxyMode: this.form.proxyMode,
      }

      this.form.parserContent = "";
      this.form.isYamlType = false;
      this.loading = true;
      this.$axios.post(remoteApiProxyUrl, params, {
        timeout: 1000 * 60 * 2 // 设置超时时间为2分钟
      }).then(res => {

        let parserContent = res.data

        if (this.isBase64(parserContent)) {
          parserContent = atob(parserContent)
        }

        this.form.nodesCount = this.countLines(parserContent)
        this.form.parserContent = parserContent

      }).catch((err) => {
        this.$message.error(err.message);
      }).finally(() => {
        this.loading = false;
      });
    },


    saveSubUrl() {
      if (this.form.sourceSubUrl !== '') {
        this.setLocalStorageItem('sub_parser_source_sub_url', this.form.sourceSubUrl)
      }
    },
    getLocalStorageItem(itemKey) {
      const now = +new Date()
      let ls = localStorage.getItem(itemKey)

      let itemValue = ''
      if (ls !== null) {
        let data = JSON.parse(ls)
        if (data.expire > now) {
          itemValue = data.value
        } else {
          localStorage.removeItem(itemKey)
        }
      }

      return itemValue
    },
    setLocalStorageItem(itemKey, itemValue) {
      const ttl = process.env.VUE_APP_CACHE_TTL
      const now = +new Date()

      let data = {
        setTime: now,
        ttl: parseInt(ttl),
        expire: now + ttl * 1000,
        value: itemValue
      }
      localStorage.setItem(itemKey, JSON.stringify(data))
    },

  }
};
</script>

<style scoped lang="scss">

::v-deep .sub-input{
   textarea{
     font-size: 18px;
     font-weight: bold;
   }
}
</style>
